<script setup lang="ts">
import { useContextsStore } from '../stores/contexts'
import type { Context } from '../../types/content'
import { VueDraggable } from 'vue-draggable-plus'
import { MAX_CONTEXTS } from '../constants/contexts'

const contextsStore = useContextsStore()

const { t } = useI18n()

const isOpen = computed({
  get: () => contextsStore.isShowingContexts,
  set: (value) => {
    contextsStore.isShowingContexts = value
  }
})

const canAddNewContext = computed(() => {
  return contextsStore.contexts.length < MAX_CONTEXTS
})

const contexts = computed({
  get: () =>
    [...contextsStore.contexts].toSorted(
      (a, b) => (a.position ?? 0) - (b.position ?? 0)
    ),
  set: (value) => contextsStore.updateContextOrder(value as Context[])
})

function handleAddNewContext() {
  if (!canAddNewContext.value) return
  contextsStore.addNewContext(t('contexts.new_context'))
}
</script>

<template>
  <ResponsiveDialog v-model="isOpen">
    <section class="space-y-4">
      <header class="flex gap-2 justify-between items-center">
        <h3 class="font-bold flex-1">{{ $t('contexts.selector_title') }}</h3>
      </header>
      <VueDraggable
        v-model="contexts"
        :animation="200"
        :delay="200"
        ghost-class="ghost"
        chosen-class="chosen"
        class="space-y-2"
      >
        <ContextItem
          v-for="context in contexts"
          :key="context.id"
          :context="context"
          @select="isOpen = false"
        />
      </VueDraggable>
      <footer class="flex justify-center">
        <UButton
          color="neutral"
          size="lg"
          class="self-center rounded-3xl"
          variant="outline"
          :disabled="!canAddNewContext"
          :label="$t('contexts.new_context')"
          icon="i-mingcute-add-line"
          @click="handleAddNewContext"
        />
      </footer>
    </section>
  </ResponsiveDialog>
</template>
